<template>
  <div class="row">
    <b-col cols="12">
      <b-tabs content-class="mt-3">
        <b-tab title="Text" active>
          <b-card no-body>
            <b-tabs pills card vertical>
              <!-- Render Tabs, supply a unique `key` to each tab -->
              <b-tab
                @click="tabClick(language)"
                v-for="(language, index) in form.formTranslations"
                :key="index"
                :title="language"
              >
                <!-- translation form wrappe -->
                <b-row>
                  <b-col cols="10">
                    <b-form-group label="Section Title">
                      <b-form-input
                        v-model="langugeInput"
                        :placeholder="sectionData.sectionTitle[transalationLanguage]"
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Section Sub Title Title">
                      <b-form-input v-model="sectionData.sectionSubTitle[transalationLanguage]" type="text"></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col cols="2">
                    <b-button
                      class="mt-3"
                      @click="addLanguageToField(language)"
                      variant="outline-success"
                    >
                      <b-spinner small v-if="isLoading"></b-spinner>Update
                    </b-button>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-tab>

        <b-tab title="Advanced">
          <b-row>
            <b-col cols="10">
              <b-form-checkbox
                class="my-2"
                v-model="isRepeatable"
                value="1"
                unchecked-value="0"
              >Section is repeatable ?</b-form-checkbox>
              <b-form-checkbox
                class="my-2"
                v-model="isSectionTitleHidden"
                value="1"
                unchecked-value="0"
              >Hide Section Title?</b-form-checkbox>
              <div v-if="form.formType == 5">
                <b-form-checkbox
                  class="my-2"
                  v-model="sectionData.advance.visibleForAdmin"
                >Visible for Admin?</b-form-checkbox>
                <b-form-checkbox
                  class="my-2"
                  v-model="sectionData.advance.visibleForClient"
                >Visible for Client?</b-form-checkbox>
              </div>
            </b-col>
            <b-col cols="2">
              <b-button @click="updateSectionRepeatable" variant="outline-success">Update</b-button>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="Conditional" v-if="sectionData.index">
          <b-col cols="6">
            <!-- enabledConditionalField -->
            <b-form-checkbox
              class="text-left my-2"
              @change="onToggleConditionalCheck"
              v-model="enabledConditionalField"
            >Enable Conditional Field</b-form-checkbox>

            <b-collapse v-model="showCollapseSection">
              <label>Select Section</label>
              <v-select
                :clearable="false"
                class="mb-2"
                :options="formSections"
                v-model="sectionValue"
                @input="getCurrentSectionElementsList"
              ></v-select>
            </b-collapse>
          </b-col>

          <b-row class="mx-1">
            <b-col cols="6">
              <b-collapse v-model="showCollapseFields" class="mt-2">
                <label>Select Field</label>
                <v-select
                  :clearable="false"
                  v-model="conditionalField"
                  class="mb-2"
                  :options="conditionalSectionElementLables"
                  lablel="label"
                  @input="getSelectedElement"
                ></v-select>
              </b-collapse>
            </b-col>

            <b-col cols="6" v-if="showCollapseOptions" class="mt-2">
              <label>Hide when selected option value is:</label>
              <v-select
                :clearable="false"
                class="mb-2"
                label="text"
                v-model="conditionalFieldValue"
                :options="selectedElementOption"
              ></v-select>
            </b-col>
          </b-row>
          <b-button
            v-if="conditionalFieldValue"
            class="mx-3 mt-3"
            variant="outline-success"
            @click="setFieldConditions"
          >Apply</b-button>
        </b-tab>
      </b-tabs>
    </b-col>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import uid from "uid";
import { Helper } from "../helpers";

export default {
  name: "SectionSettings",
  props: {
    sectionData: Object,
  },
  components: {},
  data() {
    return {
      transalationLanguage: "english",
      langugeInput: undefined,
      isRepeatable: 0,
      isLoading: false,
      isSectionTitleHidden: this.sectionData.advance.hideSectionTitle || 0,

      // for conditional filedsss
      showCollapseSection: false,
      showCollapseFields: false,
      showCollapseOptions: false,
      enabledConditionalField: false,
      formSections: [],
      sectionValue: null,
      conditionalField: null,
      conditionalFieldValue: null,
      selectedConditionalFieldValue: null,
      selectedSectionSection: null,
      selectedElementOption: [],
      conditionalSectionElements: [],
      conditionalSectionElementLables: [],
    };
  },
  mounted() {
    this.langugeInput = this.sectionData.sectionTitle[
      this.transalationLanguage
    ];
    this.isRepeatable = this.sectionData.isRepeatable;
    this.getSections();
    this.checkForConditions();
    this.addSectionExtras();
  },
  computed: {
    ...mapGetters({ form: "form1" }),
  },
  methods: {
    /**
     * chnages the langugae in the modal for translations
     */
    tabClick(language) {
      this.transalationLanguage = language.toLowerCase();

      this.langugeInput = this.sectionData.sectionTitle[
        this.transalationLanguage
      ];
    },

    makeToast(variant = null, message) {
      this.$bvToast.toast(message, {
        title: "Alert",
        variant: variant,
        solid: true,
      });
    },
    
    addSectionExtras() {
      if (!this.sectionData.sectionSubTitle) {
        // // console.log("addSectionExtras");
        let sectionSubTitle = { english: "section Sub Title" };
        Object.assign(this.sectionData, { sectionSubTitle });
      }
      if (!this.sectionData.sectionDescription) {
        let sectionDescription = { english: "" };
        Object.assign(this.sectionData, { sectionDescription });
      }
    },
    addLanguageToField(language) {
      let tempKey = language.toLowerCase();
      this.sectionData.sectionTitle[tempKey] = this.langugeInput;
      this.makeToast("success", "Language Update");
    },

    updateSectionRepeatable() {
      this.sectionData.isRepeatable = this.isRepeatable;
      this.sectionData.advance.hideSectionTitle = parseInt(
        this.isSectionTitleHidden
      );
      this.makeToast("success", "Repeatable has been successfully updated");
    },

    // for methods conditional
    checkForConditions() {
      let isConditional =
        this.sectionData.conditionCheck &&
        this.sectionData.conditionCheck.isConditional
          ? this.sectionData.conditionCheck.isConditional
          : false;
      this.enabledConditionalField = isConditional;
      if (isConditional) {
        this.showCollapseSection = true;
        this.showCollapseFields = true;
        this.showCollapseOptions = true;
        this.conditionalFieldValue = this.sectionData.condition.value;
        this.conditionalField = this.sectionData.condition.label;
        this.sectionValue = this.form.formSection[
          this.sectionData.condition.selectedSection
        ].sectionTitle[this.transalationLanguage];
      }
    },

    onToggleConditionalCheck(e) {
      this.showCollapseSection = !this.showCollapseSection;
      this.showCollapseFields = false;
      this.showCollapseOptions = false;
      this.enabledConditionalField = e;
    },

    getSections(e) {
      let formSections = this.form.formSection;
      formSections = formSections.filter((section, index) => {
        // console.log("section", section.index, this.sectionData.index);
        if (section.index < this.sectionData.index) {
          let sec = {
            label: section.sectionTitle[this.transalationLanguage],
            sectionIndex: section.index,
          };
          return this.formSections.push(sec);
        }
      });
    },

    getCurrentSectionElementsList(section) {
      this.conditionalSectionElementLables = [];
      this.conditionalSectionElements = [];
      this.selectedSectionSection = section.sectionIndex;
      let conditionalSectionElements = this.form.formSection[
        section.sectionIndex
      ].formElements;
      conditionalSectionElements = conditionalSectionElements.filter(
        (element, index) => {
          if (
            element.inputType === "radio" ||
            element.inputType === "checkbox" ||
            element.inputType === "select"
          ) {
            // // console.log("aaas", element);
            let dd = {
              label: element.label[this.transalationLanguage],
              element,
            };
            return this.conditionalSectionElementLables.push(dd);
          }
        }
      );
      this.conditionalSectionElements = conditionalSectionElements;
      this.showCollapseFields = true;
      this.showCollapseOptions = false;
      this.conditionalField = null;
    },

    getSelectedElement(selectedElement) {
      this.selectedElementOption = [];
      this.conditionalFieldValue = null;
      selectedElement.element.options.map((opt) => {
        this.selectedElementOption.push(opt.value);
      });
      this.showCollapseOptions = true;
    },

    setFieldConditions() {
      if (this.conditionalField && this.conditionalFieldValue) {
        let condition = {
          id: uid(),
          sourceSectionId: this.conditionalField.element.id,
          targetSectionId: this.sectionData.id,
          value: this.conditionalFieldValue,
          label: this.conditionalField.label,
          selectedSection: this.sectionData.index,
          forSection: true,
        };
        let elements = [
          ...this.$store.state.form1.formSection[this.selectedSectionSection]
            .formElements,
        ];
        elements = elements.map((element) => {
          if (element.options) {
            let found = element.options.map((opt) => {
              if (
                opt.value === this.conditionalFieldValue &&
                this.conditionalField.element.id === element.id
              ) {
                element.sectionConditions.push(condition);
              }
            });
          }
        });
        (this.sectionData.isConditional = this.enabledConditionalField),
          // this.sectionData.isHidden = true

          Object.assign(this.sectionData, { condition });
        this.conditionalFieldValue = null;
        this.conditionalField = null;
        Helper.makeToast(this.$bvToast, "success", "Conditional  Updated");
      } else {
        Helper.makeToast(this.$bvToast, "danger", "No Condition selected");
      }
    },
  },
};
</script>
<style>
.cursor {
  cursor: pointer;
}
</style>

